import React from 'react';
import Privacy from '../components/Privacy';

export default function PrivacyPage() {
  return <Privacy />;
}
